// NPM
import React from 'react';
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// Services
import renderService from 'services/renderService';

// Components
import SeatDistributionGraph from './SeatDistributionGraph';

function SeatDistribution() {
  const campaignConfig = useSelector(state => state.campaignConfig.value);
  if(!renderService.canRender([campaignConfig])) {
    return null;
  }

  const { title, description } = _.get(campaignConfig, "sections.SeatDistribution", {});

  return (
    <div className="SeatDistribution Signal__section">
      <h2 className="Signal__section-title">
        { title }
      </h2>
      <p className="Signal__section-description">
        { description }
      </p>

      <SeatDistributionGraph />
    </div>
  )
}

export default SeatDistribution;